import { useEffect, useRef, useState } from 'react';

const diferencialItems = [
  {
    id: 'ciencia',
    title: 'Ciência baseada em evidências',
    description: 'Cada conduta é fundamentada em estudos científicos atualizados e protocolos validados internacionalmente.',
  },
  {
    id: 'individualizado',
    title: 'Tratamento individualizado',
    description: 'Nenhum paciente é igual. Cada plano terapêutico é construído respeitando sua história e necessidades.',
  },
  {
    id: 'continuo',
    title: 'Acompanhamento contínuo',
    description: 'Sua jornada não termina na consulta. O suporte se estende por todo o período do tratamento.',
  },
  {
    id: 'integrado',
    title: 'Visão integrada da saúde',
    description: 'Corpo, mente, hormônios e metabolismo são analisados em conjunto para um resultado completo.',
  },
  {
    id: 'acolhedora',
    title: 'Experiência acolhedora',
    description: 'Ambiente pensado para que você se sinta confortável, respeitada e ouvida em cada detalhe.',
  },
  {
    id: 'sem-pressa',
    title: 'Consulta sem pressa',
    description: 'Tempo dedicado exclusivamente a você. Cada consulta é uma imersão na sua saúde e bem-estar.',
  },
];

function DiferencialCard({ item, index, inView }: { item: typeof diferencialItems[0]; index: number; inView: boolean }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="relative p-6 md:p-8 rounded-[20px] transition-all duration-500 cursor-default"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(30px)',
        transition: `all 0.6s ease-out ${index * 100}ms`,
        backgroundColor: hovered ? 'rgba(248, 247, 245, 0.04)' : 'rgba(248, 247, 245, 0.015)',
        border: hovered
          ? '1px solid rgba(200, 169, 106, 0.2)'
          : '1px solid rgba(248, 247, 245, 0.06)',
      }}
    >
      <div
        className="absolute top-0 left-6 right-6 h-[2px] rounded-full transition-all duration-500"
        style={{
          opacity: hovered ? 1 : 0,
          backgroundColor: '#C8A96A',
          boxShadow: '0 0 12px rgba(200, 169, 106, 0.3)',
        }}
      />

      <h4
        className="text-lg md:text-xl mb-3 transition-colors duration-500"
        style={{
          fontFamily: 'var(--font-heading)',
          color: hovered ? '#C8A96A' : '#F8F7F5',
          fontWeight: 600,
        }}
      >
        {item.title}
      </h4>
      <p
        className="text-xs md:text-sm leading-relaxed"
        style={{
          fontFamily: 'var(--font-body)',
          color: 'rgba(248, 247, 245, 0.45)',
          fontWeight: 300,
          lineHeight: 1.8,
        }}
      >
        {item.description}
      </p>
    </div>
  );
}

export default function Diferenciais() {
  const sectionRef = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setInView(true);
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative py-20 md:py-28 overflow-hidden" style={{ backgroundColor: '#0E1412' }}>
      <div
        className="absolute top-0 left-0 right-0 h-[1px]"
        style={{ background: 'linear-gradient(90deg, transparent 0%, rgba(200, 169, 106, 0.15) 50%, transparent 100%)' }}
      />

      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="text-center mb-16 md:mb-20">
          <p
            className="text-sm tracking-[0.15em] mb-4"
            style={{
              fontFamily: 'var(--font-body)',
              color: '#C8A96A',
              fontWeight: 500,
            }}
          >
            DIFERENCIAIS
          </p>
          <h2
            className="text-3xl md:text-5xl"
            style={{
              fontFamily: 'var(--font-heading)',
              color: '#F8F7F5',
              fontWeight: 500,
              lineHeight: 1.2,
            }}
          >
            Por que escolher a Dra. Melissa
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {diferencialItems.map((item, index) => (
            <DiferencialCard key={item.id} item={item} index={index} inView={inView} />
          ))}
        </div>
      </div>
    </section>
  );
}